import './Card.css';

function Card({ children, title = null, className = '' }) {
  return (
    <div className={`card ${className}`}>
      {title && (
        <>
          <h2 className="card__title">{title}</h2>
          <div className="card__separator" />
        </>
      )}
      <div className="card__content">{children}</div>
    </div>
  );
}

export default Card;
